import { Diff, DiffType } from '~/protos/agents'

/**
 * Canonical filepath resolver for an `agents_pb2.Diff`.
 *
 * For DELETE diffs, the canonical file path lives on `aFilePath` (the
 * "before" side) because `bFilePath` is typically empty/null — the file
 * is being removed. For every other diff type we prefer `bFilePath`
 * (the "after" side) and fall back to `aFilePath` so RENAMEs surface
 * a stable identifier.
 *
 * This used to be duplicated across `LandingDiffReviewPanel.getDiffPath`
 * and `RefactorFileViewerSlide.getDiffPath` with slightly different
 * semantics — the latter version always preferred `bFilePath`, causing
 * a mismatch when the file viewer modal was opened from `FileComponents`
 * with an `initialActivePath` derived from the former. Single shared
 * implementation here keeps both call sites aligned.
 */
export function getDiffPath(diff: Diff): string {
  const path =
    diff.diffType === DiffType.DELETE
      ? diff.aFilePath || diff.bFilePath
      : diff.bFilePath || diff.aFilePath
  return path || 'generated-file.txt'
}

/**
 * Canonical content resolver for an `agents_pb2.Diff`. DELETE diffs
 * surface the pre-deletion content via `aFileContent`; all other diff
 * types render the post-change content via `bFileContent` (falling
 * back to empty string for safety, matching the prior inline helper).
 */
export function getDiffContent(diff: Diff): string {
  if (diff.diffType === DiffType.DELETE) return diff.aFileContent || ''
  return diff.bFileContent ?? ''
}
